export default {
  list: {
    headers: {
      id: "ID",
      name: "Nazwa",
      description: "Opis",
      uid: "UID",
      isNewAccredible: "Nowe accredible?",
    },
  },
  form: {
    title: {
      information: "Informacje",
    },
    labels: {
      name: "Nazwa",
      description: "Opis",
      uid: "UID",
      isNewAccredible: "Czy nowe accredible?",
    },
    buttons: {
      addAccredible: "Dodaj accredible",
      updateAccredible: "Zapisz zmiany",
    },
  },
  buttons: {
    addAccredible: "Dodaj accredible",
  },
  generate: {
    title: "Generuj certyfikat",
    labels: {
      type: "Typ",
      user: "Uzytkownik",
      exam: "Egzamin",
      program: "Program",
    },
    placeholders: {
      user: "Wybierz uzytkownika",
      exam: "Wybierz egzamin",
      program: "Wybierz program",
    },
    types: {
      exam: "Egzamin",
      program: "Program",
    },
    buttons: {
      submit: "Generuj certyfikat",
    },
    validation: {
      type: "Wybierz typ certyfikatu",
      user: "Wybierz uzytkownika",
      model: "Wybierz element do certyfikacji",
    },
    errors: {
      fetchUsers: "Nie udalo sie pobrac listy uzytkownikow",
      fetchModels: "Nie udalo sie pobrac listy elementow",
      submit: "Nie udalo sie wygenerowac certyfikatu",
    },
    result: {
      certificateLink: "Link certyfikatu",
      certificatePreview: "Podglad certyfikatu",
      credentialId: "ID credentiala",
    },
  },
};
